<template>
  <button
    @click="addToCart()"
    class="btn btn--primary product-buy__cart-btn">{{ btnValueText }}</button>
</template>

<script>
import CartMixin from './mixins/CartMixin.vue'

export default {
  name: 'AddToCartBtn',
  props: {
    objectId: {
      type: Number,
      default: null
    },
    contentType: {
      type: Number,
      default: null
    },
    unitQuantity: {
      type: Number,
      default: 1
    },
    btnText: {
      type: String,
      default: 'В корзину'
    }
  },
  mixins: [CartMixin],
  mounted () {
    this.btnValueText = this.btnText
  },
  data() {
    return {
      step: 'add-btn',
      btnValueText: 'В корзину'
    }
  }
}
</script>

<style lang="scss">
</style>
